module.exports = __webpack_public_path__ + "img/bg_observatory.522aed20.jpg";